/**
 * Check if push notifications are enabled based on platformEndpointArn.
 * The platformEndpointArn is set by the backend when user subscribes to push notifications.
 * It can be undefined, null, empty string, or '[]' when disabled.
 * 
 * @param platformEndpointArn - The ARN from the user object
 * @returns true if notifications are enabled, false otherwise
 */
export const isPushNotificationsEnabled = (platformEndpointArn?: string | null): boolean => Boolean(
  platformEndpointArn &&
    platformEndpointArn !== '' &&
    platformEndpointArn !== '[]'
);
